// Comprehensive nationality list — alphabetical, demonym-style. Used by the
// Add Staff / Hiring / TAP screens so we have a single source of truth.
export const NATIONALITIES = [
  "Afghan", "Albanian", "Algerian", "American", "Argentine", "Armenian",
  "Australian", "Austrian", "Azerbaijani", "Bahraini", "Bangladeshi",
  "Belarusian", "Belgian", "Bhutanese", "Bolivian", "Bosnian", "Brazilian",
  "British", "Bulgarian", "Burmese", "Burundian", "Cambodian", "Cameroonian",
  "Canadian", "Chadian", "Chilean", "Chinese", "Colombian", "Comoran",
  "Congolese", "Costa Rican", "Croatian", "Cuban", "Cypriot", "Czech",
  "Danish", "Djiboutian", "Dominican", "Dutch", "Ecuadorian", "Egyptian",
  "Emirati", "Eritrean", "Estonian", "Ethiopian", "Fijian", "Filipino",
  "Finnish", "French", "Gabonese", "Gambian", "Georgian", "German", "Ghanaian",
  "Greek", "Guatemalan", "Guinean", "Haitian", "Honduran", "Hong Konger",
  "Hungarian", "Icelander", "Indian", "Indonesian", "Iranian", "Iraqi",
  "Irish", "Israeli", "Italian", "Ivorian", "Jamaican", "Japanese", "Jordanian",
  "Kazakhstani", "Kenyan", "Kuwaiti", "Kyrgyz", "Lao", "Latvian", "Lebanese",
  "Liberian", "Libyan", "Lithuanian", "Luxembourgish", "Macedonian", "Malagasy",
  "Malawian", "Malaysian", "Maldivian", "Malian", "Maltese", "Mauritanian",
  "Mauritian", "Mexican", "Moldovan", "Mongolian", "Montenegrin", "Moroccan",
  "Mozambican", "Namibian", "Nepali", "New Zealander", "Nicaraguan", "Nigerian",
  "Nigerien", "North Korean", "Norwegian", "Omani", "Pakistani", "Palestinian",
  "Panamanian", "Paraguayan", "Peruvian", "Polish", "Portuguese", "Qatari",
  "Romanian", "Russian", "Rwandan", "Salvadoran", "Saudi", "Senegalese",
  "Serbian", "Sierra Leonean", "Singaporean", "Slovak", "Slovenian", "Somali",
  "South African", "South Korean", "Spanish", "Sri Lankan", "Sudanese",
  "Swazi", "Swedish", "Swiss", "Syrian", "Taiwanese", "Tajik", "Tanzanian",
  "Thai", "Togolese", "Tunisian", "Turkish", "Turkmen", "Ugandan", "Ukrainian",
  "Uruguayan", "Uzbek", "Venezuelan", "Vietnamese", "Yemeni", "Zambian",
  "Zimbabwean", "Other",
];
